<div class="footer">
	<p>&copy; 2021 <b>Vision Indradhanu Phase 2</b> - Developed By <b>Yoginath Jorwar</b></p>	
</div>